import development from './development';
import staging from './staging';
import uat from './uat';
import production from './production';
import general from './general';
import htmlIds from './htmlIds';

const ENV = process.env.RAZZLE_ENV || 'development';

const ENV_CONSTANTS = {
  development,
  staging,
  uat,
  production,
};

export default {
  ...general,
  ...htmlIds,
  ...ENV_CONSTANTS[ENV],
};
